import Button from 'Shared/components/Button'
import Modal from 'Shared/components/Modal/Modal'
import CopyToClipboard from 'Shared/components/CopyToClipboard'
import restClient from 'Shared/hooks/restClient'
import './TargetDetailsUpdatesActions.scoped.scss'

const getDefaultDate = () => {
  const date = new Date()
  date.setMonth(date.getMonth() - 1)
  return date.toISOString().split('T')[0]
}

export default function TargetDetailsUpdatesActions() {
  const [exportPassword, setExportPassword] = useState(null)
  const [sinceDate, setSinceDate] = useState(getDefaultDate())

  const handleDateChange = (e) => {
    setSinceDate(e.target.value)
  }

  const doExport = () => {
    restClient.post(`/api/target_details_updates/export`, { since: sinceDate })
      .then(({ data: { password } }) => { setExportPassword(password) })
  }

  return (
    <div className="actions">
      <div className='export-container'>
        <Button primary onClick={doExport}>
          <SvgIconsDownload />
          Export Updates
        </Button>
        <label htmlFor="since-date" style={{ marginRight: '5px' }}>Since:</label>
        <input 
          id="since-date"
          type="date" 
          value={sinceDate} 
          onChange={handleDateChange}
          style={{ padding: '5px' }}
        />
      </div>

      <Modal open={!!exportPassword} title="Export in progress" onCancel={() => setExportPassword(null)}>
        The member details updates are exporting. You'll receive an email when the export is complete.
        Use this password to open it:
        &nbsp;<CopyToClipboard text={`${exportPassword} (click to copy)`} url={exportPassword} />
      </Modal>
    </div>
  )
}
